import { render, staticRenderFns } from "./DocumentViewCard3.vue?vue&type=template&id=0028ec5f"
import script from "./DocumentViewCard3.vue?vue&type=script&lang=js"
export * from "./DocumentViewCard3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports